import { Preferences } from '@capacitor/preferences';
import { Capacitor } from '@capacitor/core';

const LOG_BUFFER_KEY = 'debug_log_buffer';
const PENDING_DEEP_LINK_KEY = 'pending_deep_link';

export async function bufferLog(message: string, type: 'info' | 'warn' | 'error' = 'info') {
    const timestamp = new Date().toISOString().split('T')[1].split('.')[0];
    const logEntry = `[${timestamp}] [${type.toUpperCase()}] ${message}`;
    
    // Always log to standard console
    if (type === 'error') console.error(logEntry);
    else if (type === 'warn') console.warn(logEntry);
    else console.log(logEntry);

    if (Capacitor.isNativePlatform()) {
        try {
            const { value } = await Preferences.get({ key: LOG_BUFFER_KEY });
            const logs = value ? JSON.parse(value) : [];
            logs.push(logEntry);
            // Keep only last 100 logs
            if (logs.length > 100) logs.shift();
            await Preferences.set({ key: LOG_BUFFER_KEY, value: JSON.stringify(logs) });
        } catch (e) {
            console.warn('Failed to buffer log to Preferences', e);
        }
    }
}

export async function bufferDeepLink(url: string) {
    if (Capacitor.isNativePlatform()) {
        await bufferLog(`Stashing Deep Link: ${url}`);
        await Preferences.set({ key: PENDING_DEEP_LINK_KEY, value: url });
    }
}

export async function getPendingDeepLink(): Promise<string | null> {
    if (!Capacitor.isNativePlatform()) return null;
    const { value } = await Preferences.get({ key: PENDING_DEEP_LINK_KEY });
    return value;
}

export async function clearPendingDeepLink() {
    if (Capacitor.isNativePlatform()) {
        await Preferences.remove({ key: PENDING_DEEP_LINK_KEY });
    }
}

export async function dumpAndClearLogs() {
    if (!Capacitor.isNativePlatform()) return;

    try {
        const { value } = await Preferences.get({ key: LOG_BUFFER_KEY });
        if (value) {
            const logs = JSON.parse(value);
            if (logs.length > 0) {
                console.log('%c --- START OF BUFFERED NATIVE LOGS ---', 'background: #1e293b; color: #38bdf8; font-weight: bold; padding: 4px;');
                logs.forEach((log: string) => {
                    if (log.includes('[ERROR]')) console.error(log);
                    else if (log.includes('[WARN]')) console.warn(log);
                    else console.log(log);
                });
                console.log('%c --- END OF BUFFERED NATIVE LOGS ---', 'background: #1e293b; color: #38bdf8; font-weight: bold; padding: 4px;');
            }
        }
        await Preferences.remove({ key: LOG_BUFFER_KEY });
    } catch (e) {
        console.warn('Failed to dump logs', e);
    }
}
